module.exports = __webpack_public_path__ + "img/t5-i1.1d6d3702.png";